import { useEnvironmentConfiguration } from '@ori/environment';
import { getHeaders } from '@ori/fetching';
import { useTranslationsWithNamespaces } from '@ori/i18n';
import { useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration } from '@ori/static-api-client-react';

import { APP_NAME } from '../constants';
import { useLogError } from './useLogError';

export const useGetNovageSkincareConfiguration = () => {
  // istanbul ignore next
  const { tenant = '' } = useEnvironmentConfiguration();
  const { language } = useTranslationsWithNamespaces();
  const { data, error } = useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration(
    tenant,
    {
      lang: language,
    },
    {
      request: {
        headers: getHeaders({ language, sourceAppName: APP_NAME, tenant }),
      },
    },
  );
  useLogError(error);

  return data;
};
